// extracted by mini-css-extract-plugin
export default {"relative":"G5f9746","absolute":"G344606","fixed":"Gb5bcda","centerCenter":"G4430ba"};